import actionTypes from './action-types';
import mutationTypes from './mutation-types';
import getterTypes from './getter-types';

export default {
    [actionTypes.ACCEPT_ALL] ({ commit, getters }) {
        return window.axios.get(getters[getterTypes.GET_ACCEPT_ALL_URL]).then(response => {
           let data = response.data;
           commit(mutationTypes.SET_REQUIRED, data.required);
           commit(mutationTypes.SET_ANALYTICS, data.analytics);
           commit(mutationTypes.SET_MARKETING, data.marketing);
           return true;
        });
    },
    [actionTypes.ACCEPT_SELECTED] ({ commit, getters }, payload) {
        return window.axios.post(getters[getterTypes.GET_ACCEPT_SELECTED_URL], payload).then(response => {
           let data = response.data;
           commit(mutationTypes.SET_REQUIRED, data.required);
           commit(mutationTypes.SET_ANALYTICS, data.analytics);
           commit(mutationTypes.SET_MARKETING, data.marketing);
           return true;
        });
    }
}
